import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import { Autoplay, SwiperOptions } from 'swiper';
import { Swiper } from 'swiper/react';
// import "swiper/swiper.min.css";
// import 'swiper/css/swiper.min.css'

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

interface Props {
  children: ReactNode;
  setSwiper: any;
  spaceBetween?: number;
  autoplay?: boolean;
  loop?: boolean;
  slidesPerView?: number | 'auto';
  initialSlide?: number;
  breakpoints?:
    | {
        [width: number]: SwiperOptions;
        [ratio: string]: SwiperOptions;
      }
    | undefined;
  slidesOffsetBefore?: number;
  loopAdditionSlides?: number;
  noSwiping?: boolean;
  allowTouchMove?: boolean;
}

export const Carousel: React.FC<Props> = ({
  children,
  setSwiper,
  spaceBetween = 25,
  autoplay = false,
  loop = false,
  slidesPerView = 1,
  breakpoints = undefined,
  initialSlide = 0,
  slidesOffsetBefore = 0,
  loopAdditionSlides = 2,
  noSwiping = false,
  allowTouchMove = true,
}) => (
  <Container>
    <Swiper
      autoplay={autoplay ? { delay: 5000 } : false}
      speed={800}
      modules={[Autoplay]}
      noSwiping={noSwiping}
      allowTouchMove={!noSwiping}
      initialSlide={initialSlide}
      loop={loop}
      slidesOffsetBefore={slidesOffsetBefore}
      loopAdditionalSlides={loopAdditionSlides}
      loopPreventsSlide={true}
      slidesPerView={slidesPerView}
      direction="horizontal"
      spaceBetween={spaceBetween}
      onSwiper={(swiper) => setSwiper(swiper)}
      breakpoints={breakpoints}
    >
      {children}
    </Swiper>
  </Container>
);

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
